module.exports = __webpack_public_path__ + "img/card-level.f95be44f.png";